var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app-layout" } },
    [
      _c("fullscreen-loader", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.authorizeLoadStatus == 1,
            expression: "authorizeLoadStatus == 1",
          },
        ],
        staticStyle: { "min-height": "calc(100vh)" },
      }),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c("flash-message", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.flashMessage,
                expression: "flashMessage",
              },
            ],
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("nav", { staticClass: "top-navigation" }, [
        _c("div", { staticClass: "grid-x" }, [
          _c("div", { staticClass: "large-4 medium-4 small-4 cell" }, [
            _vm.app_env == "local" || _vm.app_env == "development"
              ? _c("span", { staticClass: "development-label" }, [
                  _vm._v(
                    "\n                    Testovací prostředí\n                "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "large-4 medium-4 small-4 cell" },
            [
              _c("router-link", { attrs: { to: { name: "login" } } }, [
                _c("img", {
                  staticClass: "logo",
                  attrs: {
                    src: "/img/logo-navigation-drivalia.svg",
                    alt: "Drivalia",
                  },
                }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "large-4 medium-4 small-4 cell" },
            [_c("lang-switcher")],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c("div", { staticClass: "container-lg" }, [
        _c("div", { staticClass: "left-side" }, [
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submitAuthorize.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "login-box" }, [
                _c("span", {
                  staticClass: "title",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("general.applicationName")),
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "login-label" }, [
                  _vm._v(_vm._s(_vm.$t("auth.label"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "license-plate-container-box cell centered" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "input-container",
                        class: {
                          invalid: !_vm.validations.license_plate.is_valid,
                        },
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.license_plate,
                              expression: "license_plate",
                            },
                          ],
                          staticClass: "form-input license-plateX",
                          attrs: {
                            type: "text",
                            autocomplete: "off",
                            maxlength: "9",
                            placeholder: "5A2 6125",
                          },
                          domProps: { value: _vm.license_plate },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.license_plate = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "authorize-button",
                            attrs: { type: "submit" },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("auth.submitButton")) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "validation",
                        staticStyle: { height: "20px" },
                        style: {
                          visibility: _vm.validations.license_plate.is_valid
                            ? "hidden"
                            : "visible",
                        },
                      },
                      [_vm._v(_vm._s(_vm.validations.license_plate.text))]
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "right-side" }, [
          _c("span", {
            staticClass: "services-label",
            domProps: { innerHTML: _vm._s(_vm.$t("general.servicesLabel")) },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "services-container" },
            [
              _c(
                "swiper",
                { staticClass: "swiper", attrs: { options: _vm.swiperOption } },
                [
                  _c("swiper-slide", { staticClass: "service-item" }, [
                    _c("div", { staticClass: "services-container-box" }, [
                      _c("i", { staticClass: "services-container-icon" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M8.37878 3.96457L10.7072 6.29299C10.8947 6.48053 11.0001 6.73488 11.0001 7.0001V10.0001C11.0001 10.5524 10.5524 11.0001 10.0001 11.0001H7.0001C6.73488 11.0001 6.48053 10.8947 6.29299 10.7072L3.96456 8.37878C3.89135 8.89128 3.89773 9.41508 3.98632 9.93139C4.16116 10.9505 4.64765 11.8903 5.37878 12.6214C6.10991 13.3525 7.04972 13.839 8.0688 14.0139C9.08788 14.1887 10.1361 14.0433 11.0691 13.5977C11.4515 13.4151 11.9075 13.4933 12.2072 13.793L18.2072 19.793C18.4175 20.0033 18.7027 20.1214 19.0001 20.1214C19.2975 20.1214 19.5827 20.0033 19.793 19.793C20.0033 19.5827 20.1214 19.2975 20.1214 19.0001C20.1214 18.7027 20.0033 18.4175 19.793 18.2072L13.793 12.2072C13.4933 11.9075 13.4151 11.4515 13.5977 11.0691C14.0433 10.1361 14.1887 9.08788 14.0139 8.0688C13.839 7.04972 13.3525 6.10991 12.6214 5.37878C11.8903 4.64765 10.9505 4.16117 9.93139 3.98632C9.41508 3.89773 8.89128 3.89135 8.37878 3.96457ZM6.06913 2.59773C7.37537 1.97388 8.84288 1.77034 10.2696 2.01512C11.6963 2.25991 13.012 2.94098 14.0356 3.96456C15.0592 4.98815 15.7403 6.30388 15.9851 7.7306C16.189 8.91942 16.0817 10.1366 15.6793 11.2651L21.2072 16.793C21.7925 17.3784 22.1214 18.1723 22.1214 19.0001C22.1214 19.8279 21.7925 20.6218 21.2072 21.2072C20.6218 21.7926 19.8279 22.1214 19.0001 22.1214C18.1722 22.1214 17.3783 21.7926 16.793 21.2072L11.2651 15.6793C10.1365 16.0817 8.91942 16.189 7.7306 15.9851C6.30388 15.7403 4.98814 15.0592 3.96456 14.0356C2.94098 13.0121 2.25991 11.6963 2.01512 10.2696C1.77034 8.84288 1.97388 7.37537 2.59773 6.06913C2.73763 5.77619 3.01104 5.5694 3.33099 5.5145C3.65095 5.4596 3.97765 5.56344 4.2072 5.79299L7.41431 9.0001H9.0001V7.41431L5.79299 4.20721C5.56344 3.97765 5.4596 3.65096 5.5145 3.331C5.56939 3.01104 5.77619 2.73764 6.06913 2.59773Z",
                                fill: "#18305B",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "services-container-content" }, [
                        _c("h3", [
                          _vm._v(_vm._s(_vm.$t("general.maintenanceHeadline"))),
                        ]),
                        _vm._v(" "),
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("general.maintenanceDescription")
                            ),
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("swiper-slide", { staticClass: "service-item" }, [
                    _c("div", { staticClass: "services-container-box" }, [
                      _c("i", { staticClass: "services-container-icon" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
                                fill: "#18305B",
                              },
                            }),
                            _vm._v(" "),
                            _c("circle", {
                              attrs: {
                                cx: "12",
                                cy: "12",
                                r: "2",
                                stroke: "#18305B",
                                "stroke-width": "2",
                              },
                            }),
                            _vm._v(" "),
                            _c("circle", {
                              attrs: {
                                cx: "12",
                                cy: "12",
                                r: "6",
                                stroke: "#18305B",
                                "stroke-width": "2",
                              },
                            }),
                            _vm._v(" "),
                            _c("line", {
                              attrs: {
                                x1: "12",
                                y1: "10",
                                x2: "12",
                                y2: "6",
                                stroke: "#18305B",
                                "stroke-width": "2",
                              },
                            }),
                            _vm._v(" "),
                            _c("line", {
                              attrs: {
                                x1: "12",
                                y1: "18",
                                x2: "12",
                                y2: "14",
                                stroke: "#18305B",
                                "stroke-width": "2",
                              },
                            }),
                            _vm._v(" "),
                            _c("line", {
                              attrs: {
                                x1: "6",
                                y1: "12",
                                x2: "10",
                                y2: "12",
                                stroke: "#18305B",
                                "stroke-width": "2",
                              },
                            }),
                            _vm._v(" "),
                            _c("line", {
                              attrs: {
                                x1: "14",
                                y1: "12",
                                x2: "18",
                                y2: "12",
                                stroke: "#18305B",
                                "stroke-width": "2",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "services-container-content" }, [
                        _c("h3", [
                          _vm._v(_vm._s(_vm.$t("general.tiresHeadline"))),
                        ]),
                        _vm._v(" "),
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("general.tiresDescription")
                            ),
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("swiper-slide", { staticClass: "service-item" }, [
                    _c("div", { staticClass: "services-container-box" }, [
                      _c("i", { staticClass: "services-container-icon" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M15.7071 9.2929C16.0976 9.68343 16.0976 10.3166 15.7071 10.7071L11.7071 14.7071C11.3166 15.0976 10.6834 15.0976 10.2929 14.7071L8.29291 12.7071C7.90239 12.3166 7.90239 11.6834 8.29291 11.2929C8.68343 10.9024 9.3166 10.9024 9.70712 11.2929L11 12.5858L14.2929 9.2929C14.6834 8.90238 15.3166 8.90238 15.7071 9.2929Z",
                                fill: "#18305B",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M12.6721 2.25938C12.5982 2.19219 12.5163 2.13789 12.4295 2.09667C12.2936 2.03194 12.1466 1.99995 12 2C11.8534 1.99995 11.7065 2.03194 11.5705 2.09667C11.4837 2.13789 11.4018 2.19219 11.328 2.25938C9.18803 4.1483 6.39745 5.13155 3.54573 5.00106C3.08555 4.98 2.67053 5.27602 2.54061 5.71798C2.04922 7.38958 1.89886 9.1429 2.09848 10.8738C2.29809 12.6046 2.8436 14.2777 3.70259 15.7936C4.56158 17.3094 5.71652 18.6371 7.09879 19.6978C8.48105 20.7585 10.0624 21.5305 11.7489 21.968C11.9136 22.0107 12.0864 22.0107 12.2511 21.968C13.9376 21.5305 15.519 20.7585 16.9012 19.6978C18.2835 18.6371 19.4385 17.3094 20.2974 15.7936C21.1564 14.2777 21.7019 12.6046 21.9016 10.8738C22.1012 9.1429 21.9508 7.38958 21.4594 5.71798C21.3295 5.27602 20.9145 4.98 20.4543 5.00106C17.6026 5.13155 14.812 4.1483 12.6721 2.25938ZM12 4.29725C9.78436 6.01038 7.07309 6.9626 4.27205 7.01065C4.00887 8.2015 3.94518 9.42961 4.08531 10.6446C4.25421 12.1092 4.7158 13.5249 5.44264 14.8075C6.16947 16.0902 7.14673 17.2136 8.31634 18.1112C9.4171 18.9558 10.6671 19.5841 12 19.9637C13.3329 19.5841 14.5829 18.9558 15.6837 18.1112C16.8533 17.2136 17.8306 16.0902 18.5574 14.8075C19.2842 13.5249 19.7458 12.1092 19.9147 10.6446C20.0548 9.42961 19.9912 8.2015 19.728 7.01065C16.9269 6.96259 14.2157 6.01038 12 4.29725Z",
                                fill: "#18305B",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "services-container-content" }, [
                        _c("h3", [
                          _vm._v(_vm._s(_vm.$t("general.damageHeadline"))),
                        ]),
                        _vm._v(" "),
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("general.damageDescription")
                            ),
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("swiper-slide", { staticClass: "service-item" }, [
                    _c("div", { staticClass: "services-container-box" }, [
                      _c("i", { staticClass: "services-container-icon" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M12.0001 4C11.7349 4 11.4805 4.10536 11.293 4.29289C11.1092 4.47674 11.0043 4.72479 11.0002 4.98434C11.0032 5.17963 10.9485 5.37135 10.845 5.53509C10.7699 5.65398 10.669 5.75812 10.5457 5.83816C10.5024 5.86646 10.4566 5.89148 10.4089 5.91287C9.43263 6.37863 8.60026 7.09974 8.00009 8C7.40028 8.89972 7.05483 9.94469 7.00009 11.0244V14C7.00009 14.0402 6.99767 14.0803 6.99284 14.1202C6.91259 14.7832 6.70049 15.4222 6.3703 16H17.6299C17.2997 15.4222 17.0876 14.7832 17.0073 14.1202C17.0025 14.0803 17.0001 14.0402 17.0001 14V11.0244C16.9454 9.9447 16.5999 8.89972 16.0001 8C15.3961 7.09402 14.557 6.36948 13.5726 5.90403C13.223 5.73873 13.0001 5.38669 13.0001 5C13.0001 4.73478 12.8947 4.48043 12.7072 4.29289C12.5197 4.10536 12.2653 4 12.0001 4ZM9.07008 4.35572C9.19216 3.80059 9.47057 3.28688 9.87877 2.87868C10.4414 2.31607 11.2045 2 12.0001 2C12.7957 2 13.5588 2.31607 14.1214 2.87868C14.5296 3.28688 14.808 3.80059 14.9301 4.35572C16.0261 4.97224 16.9637 5.83991 17.6642 6.8906C18.4695 8.09857 18.9309 9.50291 18.999 10.9531C18.9997 10.9687 19.0001 10.9844 19.0001 11V13.9354C19.0626 14.3815 19.2248 14.8082 19.475 15.1834C19.7355 15.5742 20.0841 15.8984 20.4929 16.1298C20.888 16.3536 21.0828 16.8156 20.9671 17.2548C20.8514 17.694 20.4543 18 20.0001 18H4.00009C3.54593 18 3.14881 17.694 3.03309 17.2548C2.91738 16.8156 3.11214 16.3536 3.50734 16.1298C3.91604 15.8984 4.26469 15.5742 4.52523 15.1834C4.7754 14.8082 4.93761 14.3815 5.00009 13.9353V11C5.00009 10.9844 5.00046 10.9687 5.00119 10.9531C5.06926 9.50291 5.53068 8.09857 6.33599 6.8906C7.03645 5.83991 7.97412 4.97224 9.07008 4.35572Z",
                                fill: "#18305B",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M9 16C9.55228 16 10 16.4477 10 17V18C10 18.5304 10.2107 19.0391 10.5858 19.4142C10.9609 19.7893 11.4696 20 12 20C12.5304 20 13.0391 19.7893 13.4142 19.4142C13.7893 19.0391 14 18.5304 14 18V17C14 16.4477 14.4477 16 15 16C15.5523 16 16 16.4477 16 17V18C16 19.0609 15.5786 20.0783 14.8284 20.8284C14.0783 21.5786 13.0609 22 12 22C10.9391 22 9.92172 21.5786 9.17157 20.8284C8.42143 20.0783 8 19.0609 8 18V17C8 16.4477 8.44772 16 9 16Z",
                                fill: "#18305B",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "services-container-content" }, [
                        _c("h3", [
                          _vm._v(
                            _vm._s(_vm.$t("general.callingActionHeadline"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("general.callingActionDescription")
                            ),
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("swiper-slide", { staticClass: "service-item" }, [
                    _c("div", { staticClass: "services-container-box" }, [
                      _c("i", { staticClass: "services-container-icon" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "24",
                              height: "24",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M18.7071 6.29289C19.0976 6.68342 19.0976 7.31658 18.7071 7.70711L17.7071 8.70711C17.3166 9.09763 16.6834 9.09763 16.2929 8.70711C15.9024 8.31658 15.9024 7.68342 16.2929 7.29289L17.2929 6.29289C17.6834 5.90237 18.3166 5.90237 18.7071 6.29289Z",
                                fill: "#18305B",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M16.2929 5.29289C16.6834 4.90237 17.3166 4.90237 17.7071 5.29289L20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V16C21 16.663 20.7366 17.2989 20.2678 17.7678C19.7989 18.2366 19.163 18.5 18.5 18.5C17.837 18.5 17.2011 18.2366 16.7322 17.7678C16.2634 17.2989 16 16.663 16 16V13C16 12.7348 15.8946 12.4804 15.7071 12.2929C15.5196 12.1054 15.2652 12 15 12H14C13.4477 12 13 11.5523 13 11C13 10.4477 13.4477 10 14 10H15C15.7957 10 16.5587 10.3161 17.1213 10.8787C17.6839 11.4413 18 12.2043 18 13V16C18 16.1326 18.0527 16.2598 18.1464 16.3536C18.2402 16.4473 18.3674 16.5 18.5 16.5C18.6326 16.5 18.7598 16.4473 18.8536 16.3536C18.9473 16.2598 19 16.1326 19 16V9.41421L16.2929 6.70711C15.9024 6.31658 15.9024 5.68342 16.2929 5.29289Z",
                                fill: "#18305B",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M6 5C5.73478 5 5.48043 5.10536 5.29289 5.29289C5.10536 5.48043 5 5.73478 5 6V20C5 20.5523 4.55228 21 4 21C3.44772 21 3 20.5523 3 20V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H12C12.7956 3 13.5587 3.31607 14.1213 3.87868C14.6839 4.44129 15 5.20435 15 6V20C15 20.5523 14.5523 21 14 21C13.4477 21 13 20.5523 13 20V6C13 5.73478 12.8946 5.48043 12.7071 5.29289C12.5196 5.10536 12.2652 5 12 5H6Z",
                                fill: "#18305B",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M9.5145 10.6425C9.98808 10.9267 10.1416 11.5409 9.85749 12.0145L9.26619 13H10.5C10.8603 13 11.1927 13.1938 11.3702 13.5073C11.5477 13.8208 11.5429 14.2056 11.3575 14.5145L9.85749 17.0145C9.57334 17.4881 8.95908 17.6417 8.4855 17.3575C8.01192 17.0734 7.85836 16.4591 8.14251 15.9855L8.73381 15H7.5C7.13973 15 6.80731 14.8062 6.6298 14.4927C6.45229 14.1792 6.45715 13.7945 6.64251 13.4855L8.14251 10.9855C8.42666 10.512 9.04092 10.3584 9.5145 10.6425Z",
                                fill: "#18305B",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M2 20C2 19.4477 2.44772 19 3 19H15C15.5523 19 16 19.4477 16 20C16 20.5523 15.5523 21 15 21H3C2.44772 21 2 20.5523 2 20Z",
                                fill: "#18305B",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M3 8C3 7.44772 3.44772 7 4 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H4C3.44772 9 3 8.55228 3 8Z",
                                fill: "#18305B",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "services-container-content" }, [
                        _c("h3", [
                          _vm._v(
                            _vm._s(_vm.$t("general.chargingStationHeadline"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("general.chargingStationDescription")
                            ),
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "swiper-pagination",
                    attrs: { slot: "pagination" },
                    slot: "pagination",
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "service-list-desktop" }, [
                _c("div", { staticClass: "services-container-box" }, [
                  _c("i", { staticClass: "services-container-icon" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M8.37878 3.96457L10.7072 6.29299C10.8947 6.48053 11.0001 6.73488 11.0001 7.0001V10.0001C11.0001 10.5524 10.5524 11.0001 10.0001 11.0001H7.0001C6.73488 11.0001 6.48053 10.8947 6.29299 10.7072L3.96456 8.37878C3.89135 8.89128 3.89773 9.41508 3.98632 9.93139C4.16116 10.9505 4.64765 11.8903 5.37878 12.6214C6.10991 13.3525 7.04972 13.839 8.0688 14.0139C9.08788 14.1887 10.1361 14.0433 11.0691 13.5977C11.4515 13.4151 11.9075 13.4933 12.2072 13.793L18.2072 19.793C18.4175 20.0033 18.7027 20.1214 19.0001 20.1214C19.2975 20.1214 19.5827 20.0033 19.793 19.793C20.0033 19.5827 20.1214 19.2975 20.1214 19.0001C20.1214 18.7027 20.0033 18.4175 19.793 18.2072L13.793 12.2072C13.4933 11.9075 13.4151 11.4515 13.5977 11.0691C14.0433 10.1361 14.1887 9.08788 14.0139 8.0688C13.839 7.04972 13.3525 6.10991 12.6214 5.37878C11.8903 4.64765 10.9505 4.16117 9.93139 3.98632C9.41508 3.89773 8.89128 3.89135 8.37878 3.96457ZM6.06913 2.59773C7.37537 1.97388 8.84288 1.77034 10.2696 2.01512C11.6963 2.25991 13.012 2.94098 14.0356 3.96456C15.0592 4.98815 15.7403 6.30388 15.9851 7.7306C16.189 8.91942 16.0817 10.1366 15.6793 11.2651L21.2072 16.793C21.7925 17.3784 22.1214 18.1723 22.1214 19.0001C22.1214 19.8279 21.7925 20.6218 21.2072 21.2072C20.6218 21.7926 19.8279 22.1214 19.0001 22.1214C18.1722 22.1214 17.3783 21.7926 16.793 21.2072L11.2651 15.6793C10.1365 16.0817 8.91942 16.189 7.7306 15.9851C6.30388 15.7403 4.98814 15.0592 3.96456 14.0356C2.94098 13.0121 2.25991 11.6963 2.01512 10.2696C1.77034 8.84288 1.97388 7.37537 2.59773 6.06913C2.73763 5.77619 3.01104 5.5694 3.33099 5.5145C3.65095 5.4596 3.97765 5.56344 4.2072 5.79299L7.41431 9.0001H9.0001V7.41431L5.79299 4.20721C5.56344 3.97765 5.4596 3.65096 5.5145 3.331C5.56939 3.01104 5.77619 2.73764 6.06913 2.59773Z",
                            fill: "#18305B",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "services-container-content" }, [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("general.maintenanceHeadline"))),
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("general.maintenanceDescription")
                        ),
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "services-container-box" }, [
                  _c("i", { staticClass: "services-container-icon" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M12.0001 4C11.7349 4 11.4805 4.10536 11.293 4.29289C11.1092 4.47674 11.0043 4.72479 11.0002 4.98434C11.0032 5.17963 10.9485 5.37135 10.845 5.53509C10.7699 5.65398 10.669 5.75812 10.5457 5.83816C10.5024 5.86646 10.4566 5.89148 10.4089 5.91287C9.43263 6.37863 8.60026 7.09974 8.00009 8C7.40028 8.89972 7.05483 9.94469 7.00009 11.0244V14C7.00009 14.0402 6.99767 14.0803 6.99284 14.1202C6.91259 14.7832 6.70049 15.4222 6.3703 16H17.6299C17.2997 15.4222 17.0876 14.7832 17.0073 14.1202C17.0025 14.0803 17.0001 14.0402 17.0001 14V11.0244C16.9454 9.9447 16.5999 8.89972 16.0001 8C15.3961 7.09402 14.557 6.36948 13.5726 5.90403C13.223 5.73873 13.0001 5.38669 13.0001 5C13.0001 4.73478 12.8947 4.48043 12.7072 4.29289C12.5197 4.10536 12.2653 4 12.0001 4ZM9.07008 4.35572C9.19216 3.80059 9.47057 3.28688 9.87877 2.87868C10.4414 2.31607 11.2045 2 12.0001 2C12.7957 2 13.5588 2.31607 14.1214 2.87868C14.5296 3.28688 14.808 3.80059 14.9301 4.35572C16.0261 4.97224 16.9637 5.83991 17.6642 6.8906C18.4695 8.09857 18.9309 9.50291 18.999 10.9531C18.9997 10.9687 19.0001 10.9844 19.0001 11V13.9354C19.0626 14.3815 19.2248 14.8082 19.475 15.1834C19.7355 15.5742 20.0841 15.8984 20.4929 16.1298C20.888 16.3536 21.0828 16.8156 20.9671 17.2548C20.8514 17.694 20.4543 18 20.0001 18H4.00009C3.54593 18 3.14881 17.694 3.03309 17.2548C2.91738 16.8156 3.11214 16.3536 3.50734 16.1298C3.91604 15.8984 4.26469 15.5742 4.52523 15.1834C4.7754 14.8082 4.93761 14.3815 5.00009 13.9353V11C5.00009 10.9844 5.00046 10.9687 5.00119 10.9531C5.06926 9.50291 5.53068 8.09857 6.33599 6.8906C7.03645 5.83991 7.97412 4.97224 9.07008 4.35572Z",
                            fill: "#18305B",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M9 16C9.55228 16 10 16.4477 10 17V18C10 18.5304 10.2107 19.0391 10.5858 19.4142C10.9609 19.7893 11.4696 20 12 20C12.5304 20 13.0391 19.7893 13.4142 19.4142C13.7893 19.0391 14 18.5304 14 18V17C14 16.4477 14.4477 16 15 16C15.5523 16 16 16.4477 16 17V18C16 19.0609 15.5786 20.0783 14.8284 20.8284C14.0783 21.5786 13.0609 22 12 22C10.9391 22 9.92172 21.5786 9.17157 20.8284C8.42143 20.0783 8 19.0609 8 18V17C8 16.4477 8.44772 16 9 16Z",
                            fill: "#18305B",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "services-container-content" }, [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("general.callingActionHeadline"))),
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("general.callingActionDescription")
                        ),
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "services-container-box" }, [
                  _c("i", { staticClass: "services-container-icon" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z",
                            fill: "#18305B",
                          },
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: {
                            cx: "12",
                            cy: "12",
                            r: "2",
                            stroke: "#18305B",
                            "stroke-width": "2",
                          },
                        }),
                        _vm._v(" "),
                        _c("circle", {
                          attrs: {
                            cx: "12",
                            cy: "12",
                            r: "6",
                            stroke: "#18305B",
                            "stroke-width": "2",
                          },
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: {
                            x1: "12",
                            y1: "10",
                            x2: "12",
                            y2: "6",
                            stroke: "#18305B",
                            "stroke-width": "2",
                          },
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: {
                            x1: "12",
                            y1: "18",
                            x2: "12",
                            y2: "14",
                            stroke: "#18305B",
                            "stroke-width": "2",
                          },
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: {
                            x1: "6",
                            y1: "12",
                            x2: "10",
                            y2: "12",
                            stroke: "#18305B",
                            "stroke-width": "2",
                          },
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: {
                            x1: "14",
                            y1: "12",
                            x2: "18",
                            y2: "12",
                            stroke: "#18305B",
                            "stroke-width": "2",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "services-container-content" }, [
                    _c("h3", [_vm._v(_vm._s(_vm.$t("general.tiresHeadline")))]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("general.tiresDescription")),
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "services-container-box" }, [
                  _c("i", { staticClass: "services-container-icon" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M18.7071 6.29289C19.0976 6.68342 19.0976 7.31658 18.7071 7.70711L17.7071 8.70711C17.3166 9.09763 16.6834 9.09763 16.2929 8.70711C15.9024 8.31658 15.9024 7.68342 16.2929 7.29289L17.2929 6.29289C17.6834 5.90237 18.3166 5.90237 18.7071 6.29289Z",
                            fill: "#18305B",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M16.2929 5.29289C16.6834 4.90237 17.3166 4.90237 17.7071 5.29289L20.7071 8.29289C20.8946 8.48043 21 8.73478 21 9V16C21 16.663 20.7366 17.2989 20.2678 17.7678C19.7989 18.2366 19.163 18.5 18.5 18.5C17.837 18.5 17.2011 18.2366 16.7322 17.7678C16.2634 17.2989 16 16.663 16 16V13C16 12.7348 15.8946 12.4804 15.7071 12.2929C15.5196 12.1054 15.2652 12 15 12H14C13.4477 12 13 11.5523 13 11C13 10.4477 13.4477 10 14 10H15C15.7957 10 16.5587 10.3161 17.1213 10.8787C17.6839 11.4413 18 12.2043 18 13V16C18 16.1326 18.0527 16.2598 18.1464 16.3536C18.2402 16.4473 18.3674 16.5 18.5 16.5C18.6326 16.5 18.7598 16.4473 18.8536 16.3536C18.9473 16.2598 19 16.1326 19 16V9.41421L16.2929 6.70711C15.9024 6.31658 15.9024 5.68342 16.2929 5.29289Z",
                            fill: "#18305B",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M6 5C5.73478 5 5.48043 5.10536 5.29289 5.29289C5.10536 5.48043 5 5.73478 5 6V20C5 20.5523 4.55228 21 4 21C3.44772 21 3 20.5523 3 20V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H12C12.7956 3 13.5587 3.31607 14.1213 3.87868C14.6839 4.44129 15 5.20435 15 6V20C15 20.5523 14.5523 21 14 21C13.4477 21 13 20.5523 13 20V6C13 5.73478 12.8946 5.48043 12.7071 5.29289C12.5196 5.10536 12.2652 5 12 5H6Z",
                            fill: "#18305B",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M9.5145 10.6425C9.98808 10.9267 10.1416 11.5409 9.85749 12.0145L9.26619 13H10.5C10.8603 13 11.1927 13.1938 11.3702 13.5073C11.5477 13.8208 11.5429 14.2056 11.3575 14.5145L9.85749 17.0145C9.57334 17.4881 8.95908 17.6417 8.4855 17.3575C8.01192 17.0734 7.85836 16.4591 8.14251 15.9855L8.73381 15H7.5C7.13973 15 6.80731 14.8062 6.6298 14.4927C6.45229 14.1792 6.45715 13.7945 6.64251 13.4855L8.14251 10.9855C8.42666 10.512 9.04092 10.3584 9.5145 10.6425Z",
                            fill: "#18305B",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M2 20C2 19.4477 2.44772 19 3 19H15C15.5523 19 16 19.4477 16 20C16 20.5523 15.5523 21 15 21H3C2.44772 21 2 20.5523 2 20Z",
                            fill: "#18305B",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M3 8C3 7.44772 3.44772 7 4 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H4C3.44772 9 3 8.55228 3 8Z",
                            fill: "#18305B",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "services-container-content" }, [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("general.chargingStationHeadline"))),
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("general.chargingStationDescription")
                        ),
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "services-container-box" }, [
                  _c("i", { staticClass: "services-container-icon" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M15.7071 9.2929C16.0976 9.68343 16.0976 10.3166 15.7071 10.7071L11.7071 14.7071C11.3166 15.0976 10.6834 15.0976 10.2929 14.7071L8.29291 12.7071C7.90239 12.3166 7.90239 11.6834 8.29291 11.2929C8.68343 10.9024 9.3166 10.9024 9.70712 11.2929L11 12.5858L14.2929 9.2929C14.6834 8.90238 15.3166 8.90238 15.7071 9.2929Z",
                            fill: "#18305B",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M12.6721 2.25938C12.5982 2.19219 12.5163 2.13789 12.4295 2.09667C12.2936 2.03194 12.1466 1.99995 12 2C11.8534 1.99995 11.7065 2.03194 11.5705 2.09667C11.4837 2.13789 11.4018 2.19219 11.328 2.25938C9.18803 4.1483 6.39745 5.13155 3.54573 5.00106C3.08555 4.98 2.67053 5.27602 2.54061 5.71798C2.04922 7.38958 1.89886 9.1429 2.09848 10.8738C2.29809 12.6046 2.8436 14.2777 3.70259 15.7936C4.56158 17.3094 5.71652 18.6371 7.09879 19.6978C8.48105 20.7585 10.0624 21.5305 11.7489 21.968C11.9136 22.0107 12.0864 22.0107 12.2511 21.968C13.9376 21.5305 15.519 20.7585 16.9012 19.6978C18.2835 18.6371 19.4385 17.3094 20.2974 15.7936C21.1564 14.2777 21.7019 12.6046 21.9016 10.8738C22.1012 9.1429 21.9508 7.38958 21.4594 5.71798C21.3295 5.27602 20.9145 4.98 20.4543 5.00106C17.6026 5.13155 14.812 4.1483 12.6721 2.25938ZM12 4.29725C9.78436 6.01038 7.07309 6.9626 4.27205 7.01065C4.00887 8.2015 3.94518 9.42961 4.08531 10.6446C4.25421 12.1092 4.7158 13.5249 5.44264 14.8075C6.16947 16.0902 7.14673 17.2136 8.31634 18.1112C9.4171 18.9558 10.6671 19.5841 12 19.9637C13.3329 19.5841 14.5829 18.9558 15.6837 18.1112C16.8533 17.2136 17.8306 16.0902 18.5574 14.8075C19.2842 13.5249 19.7458 12.1092 19.9147 10.6446C20.0548 9.42961 19.9912 8.2015 19.728 7.01065C16.9269 6.96259 14.2157 6.01038 12 4.29725Z",
                            fill: "#18305B",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "services-container-content" }, [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.$t("general.damageHeadline"))),
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("general.damageDescription")),
                      },
                    }),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("vue-recaptcha", {
        ref: "recaptcha",
        staticClass: "g-recaptcha",
        attrs: {
          sitekey: _vm.recaptcha_sitekey,
          size: "invisible",
          loadRecaptchaScript: true,
          language: _vm.$i18n.locale,
        },
        on: { verify: _vm.onVerifyRecaptcha, expired: _vm.onExpiredRecaptcha },
      }),
      _vm._v(" "),
      _c("type-modal"),
      _vm._v(" "),
      _c("cancel-scenario-modal", {
        attrs: {
          show: _vm.showCancelScenarioModal,
          "cancel-token": _vm.$route.query.st,
        },
        on: { "close-modal": _vm.closeCancelScenarioModal },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flag" }, [
      _c("div", { staticClass: "eu-container" }, [
        _c("div", { staticClass: "eu-circle" }, [
          _c("span", { staticClass: "star" }, [_vm._v("★")]),
          _vm._v(" "),
          _c("span", { staticClass: "star" }, [_vm._v("★")]),
          _vm._v(" "),
          _c("span", { staticClass: "star" }, [_vm._v("★")]),
          _vm._v(" "),
          _c("span", { staticClass: "star" }, [_vm._v("★")]),
          _vm._v(" "),
          _c("span", { staticClass: "star" }, [_vm._v("★")]),
          _vm._v(" "),
          _c("span", { staticClass: "star" }, [_vm._v("★")]),
          _vm._v(" "),
          _c("span", { staticClass: "star" }, [_vm._v("★")]),
          _vm._v(" "),
          _c("span", { staticClass: "star" }, [_vm._v("★")]),
          _vm._v(" "),
          _c("span", { staticClass: "star" }, [_vm._v("★")]),
          _vm._v(" "),
          _c("span", { staticClass: "star" }, [_vm._v("★")]),
          _vm._v(" "),
          _c("span", { staticClass: "star" }, [_vm._v("★")]),
          _vm._v(" "),
          _c("span", { staticClass: "star" }, [_vm._v("★")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }